import { isPlatformBrowser } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SlickCarouselComponent } from 'ngx-slick-carousel';
import { Subscription } from 'rxjs/internal/Subscription';
import { BehaviourSubjectService } from 'src/app/shared/services/behaviour-subject.service';
import { ApiService } from 'src/app/shared/services/apiService.service';
import { StoreVariableService } from '../store-variable.service';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-vehicle-mapping',
  templateUrl: './vehicle-mapping.component.html',
  styleUrls: ['./vehicle-mapping.component.scss']
})
export class VehicleMappingComponent implements OnInit, OnChanges {

  constructor(private ApiService: ApiService, private storeservice: StoreVariableService,private toastrService:ToastrService, @Inject(PLATFORM_ID) private platformId: Object, private router: Router, private behaviour: BehaviourSubjectService, private route: ActivatedRoute) { }

  @Input() listingData: any;
  @Output() level2 = new EventEmitter<string>();
  searchDataList: any = [];
  newsearchDataList: any = [];
  newlevel2Data: any[] = [];
  sub: Subscription = new Subscription();
  selectedLevel2ID: any;
  selectedLevel3ID: any;
  l2Data: any;
  level2Data: any[] = [];
  level3data: any[] = [];
SearchValue:any;
  userEnteredValue: any = '';
  breadCrumb: {
    l1_actual_name: string,
    l2_actual_name: string,
    l3_actual_name: string,
    l4_actual_name: string,
    filterCount: number,
  };
  imageSlider = {
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    mobileFirst: true,
    centerMode: true,
    centerPadding: 0,
    infinite: true,
    cssEase: 'linear',
    touchMove: true,
    prevArrow: '<button class="slick-prev"><img alt="right" src="assets/images/left-arrow.svg"></button>',
    nextArrow: '<button class="slick-next" id="nexslide"><img alt="right" src="assets/images/right-arrow.svg"></button>',
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,

        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1.5,
        }
      }
    ]
  };
  id: string;
  val: string;
  ngOnInit(): void {
 
      this.route.params.subscribe(params => {
        this.id = params['level1'];
        this.SearchValue=params['search']
   if (isPlatformBrowser(this.platformId)) {
        localStorage.removeItem('l2SearchData');
        localStorage.removeItem('l3SearchData');
      }
        this.selectedLevel2ID = '';
        this.selectedLevel3ID = '';
        this.storeservice.breadCrumb.l2_actual_name = '';
        this.storeservice.breadCrumb.l3_actual_name = ''
        this.storeservice.breadCrumb.l4_actual_name = ''
        this.behaviour.SearchConsoleFilterCount.next(0);
      });

      // this.listingData = this.storeservice.listingData
      this.getSmartSearch(this.id)
      if (this.listingData?.length <= 3) {
        this.listingData = this.listingData.concat(this.listingData)
      }
      this.breadCrumb = this.storeservice.breadCrumb
    
  }
  ngOnChanges(changes: SimpleChanges): void {
  }
  @ViewChild("slickModal") slickModal: SlickCarouselComponent;
  getSmartSearch(value: any) {
    this.userEnteredValue=''
    let data = {
      "search": this.SearchValue,
      "offset": 0,
      "limit": 20
    }
    this.userEnteredValue=value
    this.sub.add(this.ApiService.getSearchValue(data).subscribe({
      next: (res: any) => {
        if (res.success) {
          // let data = res.data[0].actual_value;
          let data = res.result[0].actual_value

          this.onSearchClick(data, '', '')
        }
        else {
          // document.getElementById('searchConsoleDefult').click()
          this.toastrService.warning(res.data.msg)
          return;
        }
      },
      complete() {

      }
    }))
  }

  getChildValue(event, val) {

    if (isPlatformBrowser(this.platformId)) {
      if (event == "search1") {
        localStorage.removeItem('l1SearchData')
        localStorage.removeItem('l2SearchData')
        localStorage.removeItem('l3SearchData')
        this.storeservice.breadCrumb.l4_actual_name = ''
        this.storeservice.breadCrumb.l1_actual_name = '';
        this.storeservice.breadCrumb.l2_actual_name = '';
        this.storeservice.breadCrumb.l3_actual_name = '';
        this.selectedLevel2ID = '';
        this.selectedLevel3ID = '';
      }
    }
  }
  nextSlide() {
    this.slickModal.slickNext();
  }
  getLevel2Data(value: any) {
    this.storeservice.isclick.next(false)
    this.storeservice.isclickid=0
    if (isPlatformBrowser(this.platformId)) {
      this.selectedLevel3ID = null;
      localStorage.setItem('pageLevel', '2');
      this.onSearchClick('', value, '');
    }
  }
  clearLocalStorageData() {
    if (isPlatformBrowser(this.platformId)) {
      if (localStorage.getItem('pageLevel') === '1') {
        localStorage.removeItem('l2SearchData');
        localStorage.removeItem('l3SearchData');
      }
      if (localStorage.getItem('pageLevel') === '2') {
        localStorage.removeItem('l3SearchData');
      }
    }
  }
  onSearchClick(level1: any, level2: any, level3: any) {
    if (isPlatformBrowser(this.platformId)) {
      this.clearLocalStorageData();
      if (level3 != '' && level3 != undefined && level3 != null)
        localStorage.setItem('pageLevel', '3');

      if (!localStorage.getItem('l1SearchData') || level1 != '') {
        this.selectedLevel2ID = null;
        this.selectedLevel3ID = null;
        localStorage.removeItem('l2SearchData')
        this.l2Data = [];
        this.level3data = [];
        this.level2Data = [];
        localStorage.setItem('l1SearchData', level1);
        localStorage.setItem('pageLevel', '1');
      }
      if (
        localStorage.getItem('pageLevel') == '2' &&
        !localStorage.getItem('l2SearchData')
      ) {
        localStorage.removeItem('l3SearchData');
        this.selectedLevel3ID = null;
        localStorage.setItem('l2SearchData', JSON.stringify(level2));
      }
      if (localStorage.getItem('l2SearchData')) {
        localStorage.removeItem('l3SearchData');
        this.selectedLevel3ID = null;
        this.l2Data = JSON.parse(localStorage.getItem('l2SearchData'));
      }
      if (
        this.level2Data?.length > 1 &&
        localStorage.getItem('pageLevel') == '3' &&
        !localStorage.getItem('l3SearchData')
      ) {
        localStorage.setItem('l3SearchData', level3);
      }
      let data = {
        level1: localStorage.getItem('l1SearchData')
          ? localStorage.getItem('l1SearchData')
          : level1,
        level2: this.l2Data ? this.l2Data.l2_actual_name : level2.l2_actual_name,
        level3: localStorage.getItem('l3SearchData')
          ? localStorage.getItem('l3SearchData')
          : level3,
        search: this.SearchValue ? this.SearchValue : ''
      };
      this.sub.add(
        this.ApiService.advanceSearch(data).subscribe({
          next: (res: any) => {
            if (res.success) {
              this.searchDataList = res.data;
              let tempBreadCrumb = {
                l1_actual_name: '',
                l2_actual_name: '',
                l3_actual_name: '',
                l4_actual_name: '',
                filterCount: 0
              }
              if (level1 != '') {
                tempBreadCrumb.l1_actual_name = res.data.l1_actual_name
              }
              if (localStorage.getItem('pageLevel') == '1') {
                let data = res.data.data
                this.listingData = data
                if (this.listingData?.length <= 3) {
                  this.listingData = this.listingData.concat(this.listingData)
                }
              }
              if (localStorage.getItem('pageLevel') == '3') {
                tempBreadCrumb.l1_actual_name = res.data.l1_actual_name
                tempBreadCrumb.l2_actual_name = res.data.l2_actual_name
                this.level3data = res.data.data ? res.data.data : [];
              }
              if (localStorage.getItem('pageLevel') == '2') {
                tempBreadCrumb.l1_actual_name = res.data.l1_actual_name
                tempBreadCrumb.l2_actual_name = res.data.l2_actual_name
                this.level2Data = this.searchDataList.data
                this.newsearchDataList = this.searchDataList;
                this.newlevel2Data = this.level2Data
                if (this.newsearchDataList) {
                  this.storeservice.newsearchDataList = this.newsearchDataList
                  this.storeservice.newlevel2Data = this.newlevel2Data
                  this.breadCrumb = tempBreadCrumb;
                  this.storeservice.breadCrumb = this.breadCrumb
              this.router.navigate(['advancesearch/',this.SearchValue, this.storeservice.breadCrumb.l1_actual_name, this.storeservice.breadCrumb.l2_actual_name]);

                }
              }
              this.breadCrumb = tempBreadCrumb;
              this.storeservice.breadCrumb = this.breadCrumb
              // this.router.navigate(['advancesearch/', this.storeservice.breadCrumb.l1_actual_name, this.storeservice.breadCrumb.l2_actual_name]);
            }
          },
          error: (error: any) => { },
          complete: () => {

          },
        })
      );
    }
  }
}
